import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import VerificationBanner from './VerificationBanner'

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-kiniela-bg">
      <Navbar />
      <VerificationBanner />
      <main className="flex-1 bg-kiniela-bg">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
